import { WAVE_PROD } from '@anm/constants/domains';
import isMobile from '@anm/helpers/is/isMobile';
import { injectGlobal } from '@anm/helpers/stateful/injectGlobal';
import { Manifest } from '@anm/hosting-player';
import { useState, FC } from 'react';
import Slider, { Settings } from 'react-slick';

import VideoSlide from './VideoSlide';
import { SectionWrapper, SliderArrowWrapper, SliderCounter, SliderWrapper, Title } from './Wrapper';

type IconProps = {
  name: string;
  href: string;
};

export type SlideProps = {
  name: string;
  videoId: string;
  position: string;
  icons: IconProps[];
};

export type VideoSliderProps = {
  sliderData: SlideProps[];
  videoData?: { [key: string]: Manifest };
};

export type SliderArrowVariants = 'left' | 'right';

type ArrowProps = {
  className: string;
  direction: SliderArrowVariants;
};

const SliderArrow = (props: ArrowProps) => <SliderArrowWrapper {...props} className="slider-custom-arrow" />;

const VideoSlider: FC<VideoSliderProps> = ({ videoData, sliderData }) => {
  const SLIDE_TO_SHOW = isMobile() ? 1 : 3;
  const [currentPage, setCurrentPage] = useState(1);

  const settings: Settings = {
    speed: 700,
    infinite: true,
    dots: isMobile(),
    swipe: isMobile(),
    slidesToShow: SLIDE_TO_SHOW,
    slidesToScroll: SLIDE_TO_SHOW,
    afterChange: (currentSlide: number) => {
      const INDEX_OFFSET = 1;
      const nextPage = currentSlide / SLIDE_TO_SHOW + INDEX_OFFSET;
      setCurrentPage(nextPage);
    },
    prevArrow: <SliderArrow direction="left" className="slider-custom-arrow" />,
    nextArrow: <SliderArrow direction="right" className="slider-custom-arrow" />
  };
  const allPages = Math.ceil(sliderData?.length / SLIDE_TO_SHOW);
  const playerSrc = `${WAVE_PROD}embed/player.js`;

  injectGlobal({
    head: <script src={playerSrc} async />
  });

  return (
    <SectionWrapper>
      <Title level={2} title="What our customers say" />
      {!isMobile() && (
        <SliderCounter>
          <span>{currentPage}</span> / {allPages}
        </SliderCounter>
      )}
      <SliderWrapper>
        <Slider {...settings}>
          {sliderData.map(({ videoId, ...rest }) => (
            <VideoSlide key={videoId} manifest={videoData?.[videoId]!} {...{ videoId, ...rest }} />
          ))}
        </Slider>
      </SliderWrapper>
    </SectionWrapper>
  );
};

export default VideoSlider;
